var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1405 29.4286C14.8947 29.4286 16.3176 28.0057 16.3176 26.25H9.96346C9.96346 28.0057 11.3864 29.4286 13.1405 29.4286ZM23.8379 21.9932C22.8784 20.9621 21.083 19.4111 21.083 14.3304C21.083 10.4714 18.3772 7.3822 14.7288 6.62431V5.58929C14.7288 4.7117 14.0176 4 13.1405 4C12.2634 4 11.5522 4.7117 11.5522 5.58929V6.62431C7.90384 7.3822 5.19808 10.4714 5.19808 14.3304C5.19808 19.4111 3.40269 20.9621 2.44315 21.9932C2.14516 22.3135 2.01305 22.6965 2.01554 23.0714C2.021 23.8859 2.66019 24.6607 3.60979 24.6607H22.6713C23.6209 24.6607 24.2606 23.8859 24.2655 23.0714C24.268 22.6965 24.1359 22.313 23.8379 21.9932Z",
    fill: "#C5C7CD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0883,
    cy: 7.17801,
    r: 5.95982,
    fill: "#3751FF",
    stroke: "#F7F8FC",
    strokeWidth: 2.38393
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.354a92f2a9bb1298ed109fa6be4b7fe3.svg";
export { ForwardRef as ReactComponent };